import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';

import { OrganizationDTOStatus } from '@/api/generated';
import DateRange from '@/components/fields/DateRange/DateRange';
import Field from '@/components/fields/Field';
import GeneralStatusSelect from '@/components/fields/GeneralStatusSelect';
import IndustryDropdownSelect from '@/views/fields/IndustryDropdownSelect/IndustryDropdownSelect';
import CreateByDropdownSelect from '@/views/fields/UserDropdownSelect/CreatedByDropdownSelect';

import DropdownSection from './DropdownSection';

interface OrganizationSectionProps {
  name: string;
}

const ORG_STATUSES = [
  OrganizationDTOStatus.ACTIVE,
  OrganizationDTOStatus.DRAFT,
  OrganizationDTOStatus.INACTIVE,
  OrganizationDTOStatus.ONBOARDING,
  OrganizationDTOStatus.ON_HOLD
];

const OrganizationSection: FC<OrganizationSectionProps> = props => {
  const { t } = useTranslation('filters');
  const { name } = props;

  return (
    <DropdownSection title={t('filters.sections.organization.title')} {...props}>
      <Field
        component={GeneralStatusSelect}
        name={`${name}.status`}
        label={t('filters.sections.organization.status')}
        innerProps={{
          activeOptions: ORG_STATUSES
        }}
        withFormControl
      />
      <Divider />
      <Field
        component={CreateByDropdownSelect}
        name={`${name}.createdBy`}
        label={t('filters.sections.organization.createdBy')}
        withFormControl
      />
      <Divider />
      <Field
        component={IndustryDropdownSelect}
        name={`${name}.industry`}
        label={t('filters.sections.organization.industry')}
        withFormControl
      />
      <Divider />
      <Field
        component={DateRange}
        name={`${name}.createdAt`}
        label={t('filters.sections.organization.creationDate')}
        withFormControl
      />
      <Divider />
      <Field
        component={DateRange}
        name={`${name}.lastActivity`}
        label={t('filters.sections.organization.updateDate')}
        withFormControl
      />
    </DropdownSection>
  );
};

export default OrganizationSection;
